import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../styles/styles";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { server } from "../../server";
import { toast } from "react-toastify";
import { clearCart } from "../../redux/actions/cart"; // Import clearCart action
import { logEvent } from "../../analytics/ga4"; 
const Payment = () => {
  const [orderData, setOrderData] = useState([]);
  const [open, setOpen] = useState(false);
  const { user } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const dispatch = useDispatch(); 
  const [currentBalance, setCurrentBalance] = useState(0);
  const [showPopup, setShowPopup] = useState(true);


  useEffect(() => {
    const fetchUserBalance = async () => {
      try {
        const { data } = await axios.get(`${server}/user/balance`, {
          withCredentials: true,
        });
        setCurrentBalance(data.balance);
      } catch (error) {
        console.error("Error fetching user balance:", error);
      }
    };

    fetchUserBalance();
  }, []);


  useEffect(() => {
    
    window.scrollTo(0, 0);
    const handleBeforeUnload = (event) => {
      if (isProcessing) {
        event.preventDefault();
        event.returnValue = ""; // Display a warning message on page leave
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isProcessing]);

  useEffect(() => {
    const orderData = JSON.parse(localStorage.getItem("latestOrder"));
    if (orderData) {
      setOrderData(orderData);
    }
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const getSelectedPaymentMethod = (select) => {
    switch (select) {
      case 1:
        return "Razorpay";
      case 2:
        return "Cash On Delivery";
      case 3:
        return "Pay on Credit";
      default:
        throw new Error("Invalid payment method selected");
    }
  };

  const createOrder = (data, actions) => {
    return actions.order
      .create({
        purchase_units: [
          {
            description: "Moon",
            amount: {
              currency_code: "INR",
              value: orderData?.orderTotalPriceWithCommission,
            },
          },
        ],
        application_context: {
          shipping_preference: "NO_SHIPPING",
        },
      })
      .then((orderID) => {
        return orderID;
      });
  };

  const order = {
    cart: orderData?.cart,
    shippingAddress: orderData?.shippingAddress,
    user: user && user,
    orderTotalPriceWithCommission: parseFloat(orderData?.orderTotalPriceWithCommission),
    orderTotalPriceWithoutCommission: parseFloat(orderData?.orderTotalPriceWithoutCommission),
    subTotalPriceWithCommission: parseFloat(orderData?.subTotalPriceWithCommission),
    subTotalPriceWithoutCommission: parseFloat(orderData?.subTotalPriceWithoutCommission),
    shippingCharge: parseFloat(orderData?.shipping || 0),
    discountPrice: parseFloat(orderData?.discountPrice || 0),
  };

  const paymentData = {
    amount: Math.round(orderData?.orderTotalPriceWithCommission * 100),
  };

  // <-- Function to prepare e-commerce items for GA4

  const prepareEcommerceItems = (cart) => {
    const items = cart.map((item) => {
      return {
        item_id: item._id,
        item_name: item.name,
        item_category: item.category,
        price: parseFloat(item.totalPriceWithCommission),
        quantity: item.qty,
      };
    });
    return items;
  };
 

  // <-- Function to send `purchase` event to GA4
  const sendPurchaseEvent = (order, paymentMethod) => {

    logEvent("purchase", {
      currency: "INR",
      transaction_id: order.orderId || `T${Date.now()}`, // Ensure unique transaction ID
      value: parseFloat(order.orderTotalPriceWithCommission),
      payment_method: paymentMethod,
      items: prepareEcommerceItems(order.cart),
      zip_code: order.shippingAddress.zipCode,
    });
  };

  const openRazorpayPayment = async (e, select) => {
    e.preventDefault();
    if (isProcessing) {
      toast.info("Order is already being processed.");
      return;
    }
  
    setIsProcessing(true);
    setLoadingMessage("Processing your payment. Please do not reload or navigate away.");
  
    try {
      // Calculate the additional fee of 2.05%
      const baseAmount = parseFloat(orderData?.orderTotalPriceWithCommission);
      const feeAmount = baseAmount * 0.0205;
      const totalAmountWithFee = baseAmount + feeAmount;
  
      // Convert to paisa
      const updatedPaymentAmount = Math.round(totalAmountWithFee * 100);
  
      // Create Razorpay order using the updated amount
      const { data: { orderId, razorpayKey } } = await axios.post(
        `${server}/payment/razorpay/order`,
        { amount: updatedPaymentAmount }
      );
  
      const options = {
        key: razorpayKey,
        amount: updatedPaymentAmount,
        currency: "INR",
        name: "HAWLER",
        description: "Order Payment",
        order_id: orderId,
        handler: async function (response) {
          const { razorpay_payment_id, razorpay_order_id, razorpay_signature } = response;
  
          // Update order payment info
          order.paymentInfo = {
            id: razorpay_payment_id,
            status: "succeeded",
            type: "Razorpay",
          };
  
          // IMPORTANT: Update the order total to include the extra fee
          order.orderTotalPriceWithCommission = totalAmountWithFee;
  
          const paymentMethod = getSelectedPaymentMethod(select);
  
          try {
            await axios.post(`${server}/order/create-order`, {
              ...order,
              paymentMethod,
              orderTotalPrice: order.orderTotalPriceWithCommission,
              shopTotals: orderData.shopTotals,
              razorpay_payment_id,
              razorpay_order_id,
              razorpay_signature,
            });
            setOpen(false);
            // Send purchase event to GA4
            sendPurchaseEvent(order, paymentMethod);
            localStorage.setItem("cartItems", JSON.stringify([]));
            localStorage.setItem("latestOrder", JSON.stringify([]));
            dispatch(clearCart());
            navigate("/order/success");
            toast.success("Order successful!");
          } catch (error) {
            toast.error(error.message);
          } finally {
            setIsProcessing(false);
            setLoadingMessage("");
          }
        },
        prefill: {
          name: user?.name,
          email: user?.email,
          contact: user?.phoneNumber,
        },
        theme: {
          color: "#F37254",
        },
        modal: {
          ondismiss: function () {
            setIsProcessing(false);
            setLoadingMessage("");
            toast.error("Payment was not completed. Please try again.");
          },
        },
      };
  
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      toast.error("Payment failed. Please try again.");
      setIsProcessing(false);
      setLoadingMessage("");
    }
  };
  

  const cashOnDeliveryHandler = async (e, select) => {
    e.preventDefault();
    if (isProcessing) {
      toast.info("Order is already being processed.");
      return;
    }
  
    // Validate Coimbatore pincode for Cash on Delivery
    const zipCode = String(orderData?.shippingAddress?.zipCode || '');
    if (!zipCode.startsWith('641') && !zipCode.startsWith('642')) {
      toast.error("Cash on delivery not applicable for this location since we are using India Post. We serve only Coimbatore, Tamil Nadu.");
      return;
    }
  
    setIsProcessing(true);
    setLoadingMessage("Processing your order. Please do not reload or navigate away.");
  
    // Rest of the existing code for order processing...
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
  
    order.paymentInfo = {
      type: "Cash On Delivery",
    };
    const paymentMethod = getSelectedPaymentMethod(select);
    try {
      const response = await axios.post(`${server}/order/create-order`, {
        ...order,
        paymentMethod,
        orderTotalPrice: order.orderTotalPriceWithCommission,
        shopTotals: orderData.shopTotals,
      }, config);
    
      if (response.status === 201) {
        setOpen(false);
        sendPurchaseEvent(order, paymentMethod);
        localStorage.setItem("cartItems", JSON.stringify([]));
        localStorage.setItem("latestOrder", JSON.stringify([]));
        dispatch(clearCart());
        navigate("/order/success");
        toast.success("Order successful!");
      } else {
        toast.error("Failed to create order. Please try again.");
      }
    } catch (error) {
      toast.error("Failed to create order. Please check your network connection and try again.");
    } finally {
      setIsProcessing(false);
      setLoadingMessage("");
    }
  };

  const creditPaymentHandler = async (e, select) => {
    e.preventDefault();
    if (isProcessing) {
      toast.info("Order is already being processed.");
      return;
    }
  
    if (!user.creditApproved) {
      toast.error("You are not a Credit approved user. Contact the admin office to get credit approval.");
      return;
    }
  
    const orderAmount = parseFloat(order.orderTotalPriceWithCommission);
    const availableCredit = user.creditLimit - currentBalance;
    if (currentBalance + orderAmount > user.creditLimit) {
      
      toast.error("Your credit limit has been exceeded. Please pay the previous balance to use the Pay on Credit option.");
      toast.error(`Your available credit is Rs ${availableCredit.toFixed(2)}. You cannot place this order.`);
      return;
    }
  
    setIsProcessing(true);
    setLoadingMessage("Processing your order. Please do not reload or navigate away.");

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      order.paymentInfo = {
        type: "Credit",
      };
      const paymentMethod = getSelectedPaymentMethod(select);
      await axios.post(`${server}/order/create-order`, {
        ...order,
        paymentMethod,
        orderTotalPrice: order.orderTotalPriceWithCommission,
        shopTotals: orderData.shopTotals,
      }, config);

      // Send `purchase` event to GA4
      sendPurchaseEvent(order, paymentMethod);

      setOpen(false);
      localStorage.setItem("cartItems", JSON.stringify([]));
      localStorage.setItem("latestOrder", JSON.stringify([]));
      localStorage.setItem("cartItems", JSON.stringify([]));
      localStorage.setItem("latestOrder", JSON.stringify([]));
      dispatch(clearCart());
     navigate("/order/success"); // Navigate only after clearing the cart
      toast.success("Order successful!");
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsProcessing(false);
      setLoadingMessage("");
    }
  };

  return (
    <div className="w-full flex flex-col items-center py-8">
      {showPopup && (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  }}>
    <div style={{
      backgroundColor: '#fff',
      padding: '20px',
      borderRadius: '8px',
      maxWidth: '90%',
      width: '400px',
      textAlign: 'center',
    }}>
      <p style={{ fontSize: '16px', marginBottom: '20px' }}>
      Currently, we are only accepting Cash on Delivery inside Coimbatore. For orders outside Coimbatore, Tamil Nadu, please opt for other payment options.
      </p>
      <button onClick={() => setShowPopup(false)} style={{
        padding: '10px 20px',
        backgroundColor: '#1d741d',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
      }}>
        Close
      </button>
    </div>
  </div>
)}

      {isProcessing && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50">
          <div className="bg-white p-4 rounded shadow">
            <h2 className="text-lg font-bold">{loadingMessage}</h2>
          </div>
        </div>
      )}
      <div className="w-[90%] 1000px:w-[70%] block 800px:flex">
        <div className="w-full 800px:w-[65%]">
          <PaymentInfo
            user={user}
            open={open}
            setOpen={setOpen}
            createOrder={createOrder}
            openRazorpayPayment={openRazorpayPayment}
            cashOnDeliveryHandler={cashOnDeliveryHandler}
            creditPaymentHandler={creditPaymentHandler}
          />
        </div>
        <div className="w-full 800px:w-[35%] 800px:mt-0 mt-8">
          <CartData orderData={orderData} />
        </div>
      </div>
    </div>
  );
};
const PaymentInfo = ({
  user,
  open,
  setOpen,
  onApprove,
  createOrder,
  openRazorpayPayment,
  cashOnDeliveryHandler,
  creditPaymentHandler,
}) => {
  const [select, setSelect] = useState(1);

  return (
    
    <div className="w-full 800px:w-[95%] bg-[#fff] rounded-md p-5 pb-8">
      {/* Select buttons */}
      <div>
        {/* Razorpay Payment Option */}
        <div className="flex w-full pb-5 border-b mb-2">
          <div
            className="w-[25px] h-[25px] rounded-full bg-transparent border-[3px] border-[#1d1a1ab4] relative flex items-center justify-center cursor-pointer"
            onClick={() => setSelect(1)}
          >
            {select === 1 && <div className="w-[13px] h-[13px] bg-[#1d1a1acb] rounded-full" />}
          </div>
          <h4 className="text-[18px] pl-2 font-[600] text-[#000000b1]">
            Pay Online(With Card / Net Banking/ Wallet /Pay later) 
          </h4>
        </div>
        {select === 1 && (
          <div className="w-full flex flex-col border-b space-y-2">
            <p className="text-[14px] font-[600] text-red-500">
              Note: Additional 2.05% fee will be added to payment through Razorpay.
            </p>
            <button
              className={`${styles.button} !bg-[#1d741d] text-white h-[45px] rounded-[5px] cursor-pointer text-[18px] font-[600] hover:bg-[#39b439] transition-colors duration-300`}
              onClick={(e) => openRazorpayPayment(e, select)} // Pass the event and selected option
            >
              Pay Now
            </button>
          </div>
        )}
      </div>
      
      <br />
      {/* Cash on Delivery Option */}
      <div>
        <div className="flex w-full pb-5 border-b mb-2">
          <div
            className="w-[25px] h-[25px] rounded-full bg-transparent border-[3px] border-[#1d1a1ab4] relative flex items-center justify-center cursor-pointer"
            onClick={() => setSelect(2)}
          >
            {select === 2 && (
              <div className="w-[13px] h-[13px] bg-[#1d1a1acb] rounded-full" />
            )}
          </div>
          <h4 className="text-[18px] pl-2 font-[600] text-[#000000b1]">
            Cash on Delivery
          </h4>
        </div>

        {/* Cash on Delivery Form */}
        {select === 2 && (
          <div className="w-full flex">
            <form className="w-full" onSubmit={(e) => cashOnDeliveryHandler(e, select)}>
              <input
                type="submit"
                value="Confirm"
                className={`${styles.button} !bg-[#1d741d] text-[#fff] h-[45px] rounded-[5px] cursor-pointer text-[18px] font-[600]`}
              />
            </form>
          </div>
        )}
      </div>

      {/* Pay on Credit Option */}
      <div>
        <div className="flex w-full pb-5 border-b mb-2">
          <div
            className="w-[25px] h-[25px] rounded-full bg-transparent border-[3px] border-[#1d1a1ab4] relative flex items-center justify-center cursor-pointer"
            onClick={() => setSelect(3)}
          >
            {select === 3 && (
              <div className="w-[13px] h-[13px] bg-[#1d1a1acb] rounded-full" />
            )}
          </div>
          <h4 className="text-[18px] pl-2 font-[600] text-[#000000b1]">
            Pay on Credit
          </h4>
        </div>

        {/* Pay on Credit Form */}
        {select === 3 && (
          <div className="w-full flex">
            <form className="w-full" onSubmit={(e) => creditPaymentHandler(e, select)}>
              <input
                type="submit"
                value="Confirm"
                className={`${styles.button} !bg-[#1d741d] text-[#fff] h-[45px] rounded-[5px] cursor-pointer text-[18px] font-[600]`}
              />
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

const CartData = ({ orderData }) => {
  const shipping = orderData?.shipping?.toFixed(2); // Updated to use shippingCharge
  return (
    <div className="w-full bg-white rounded-lg shadow-md p-6">
      {/* Subtotal */}
      <div className="flex justify-between items-center">
        <h3 className="text-base font-medium text-gray-700">Subtotal:</h3>
        <h5 className="text-lg font-semibold text-gray-800">
          Rs {orderData?.subTotalPriceWithCommission?.toFixed(2)}
        </h5>
      </div>
  
      {/* Shipping */}
      <div className="flex justify-between items-center mt-4">
        <h3 className="text-base font-medium text-gray-700">Shipping:</h3>
        <h5 className="text-lg font-semibold text-gray-800">Rs {shipping}</h5>
      </div>
  
      {/* Discount */}
      <div className="flex justify-between items-center mt-4 border-b pb-4">
        <h3 className="text-base font-medium text-gray-700">Discount:</h3>
        <h5 className="text-lg font-semibold text-gray-800">
          {orderData?.discountPrice ? `Rs ${orderData.discountPrice}` : "-"}
        </h5>
      </div>
  
      {/* Total */}
      <div className="flex justify-between items-center mt-4">
        <h5 className="text-xl font-bold text-gray-900">Total:</h5>
        <h5 className="text-xl font-bold text-gray-900">
          ₹ {orderData?.orderTotalPriceWithCommission}
        </h5>
      </div>
  
      {/* Free Delivery Message */} 
      <div className="mt-6 text-center">
        <p className="text-sm text-gray-600">
          For orders above Rs 3000, delivery is free only inside Tamilnadu.
        </p>
        {orderData?.subTotalPriceWithCommission < 3000 && (
          <p className="mt-2 text-sm text-red-600">
            Add items worth Rs{" "}
            {(3000 - orderData?.subTotalPriceWithCommission).toFixed(2)} to get
            free delivery.
          </p>
        )}
      </div>
    </div>
  );
  
};


export default Payment;
